import { render, staticRenderFns } from "./ManageStores.vue?vue&type=template&id=680117ae"
import script from "./ManageStores.vue?vue&type=script&lang=js"
export * from "./ManageStores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports